export default "__VITE_ASSET__DXHXcFix__"